import { AlertTriangle, ShieldAlert } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { WorkerAlert, WorkerTabKey } from "../lib/alerts";

// Bandeau d'alertes proactif : n'apparaît que si au moins une pathologie est
// détectée. Chaque alerte est cliquable pour basculer sur l'onglet concerné.
export function AlertsBanner({
  alerts,
  onNavigate,
}: {
  alerts: WorkerAlert[];
  onNavigate?: (tab: WorkerTabKey) => void;
}) {
  if (alerts.length === 0) return null;
  const hasDanger = alerts.some((a) => a.severity === "danger");

  return (
    <Card className={cn("border-l-4", hasDanger ? "border-l-destructive" : "border-l-amber-500")}>
      <div className="flex flex-col gap-1 p-3">
        {alerts.map((a) => {
          const Icon = a.severity === "danger" ? ShieldAlert : AlertTriangle;
          const color = a.severity === "danger" ? "text-destructive" : "text-amber-500";
          const clickable = Boolean(a.tab && onNavigate);
          return (
            <button
              key={a.id}
              type="button"
              disabled={!clickable}
              onClick={() => a.tab && onNavigate?.(a.tab)}
              className={cn(
                "flex items-start gap-3 rounded-md p-2 text-left",
                clickable ? "cursor-pointer hover:bg-muted/50" : "cursor-default",
              )}
            >
              <Icon className={cn("mt-0.5 h-4 w-4 shrink-0", color)} />
              <div className="min-w-0">
                <div className="text-sm font-medium">{a.title}</div>
                <div className="text-xs text-muted-foreground">{a.detail}</div>
              </div>
            </button>
          );
        })}
      </div>
    </Card>
  );
}
